import { Model }            from '@mathquis/modelx';
import { computed }         from 'mobx';
import { ApiConnector }     from 'connectors/ApiConnector';
import currentSession       from 'utils/currentSession';
import ConfigProxy          from 'utils/ConfigProxy';
import type ConnectorResult from '@mathquis/modelx/lib/types/connectorResult';

export const connector = new ApiConnector({
  baseURL: ConfigProxy.get('API_ENTRYPOINT'),
});

connector.setCurrentSessionStore(currentSession);

export default class ApiModel extends Model {
  static get connector() {
    return connector;
  }

  public res: any;

  onSaveSuccess(connectorResult: ConnectorResult, options: object = {}) {
    super.onSaveSuccess(connectorResult, options);
    this.res = connectorResult.res;
  }

  patch(attributes = {}, options = {}) {
    return this.save({ ...options, patchAttributes: attributes });
  }

  // public get id() {
  //   return this.get('id');
  // }

  @computed
  get iri() {
    return this.get('@id');
  }
}
